<button [class]="'skf-btn ' + theme"
        [class.disabled]="disabled"
        [class.is-rounded]="isRounded"
        [class.mat-elevation-z2]="elevated"
        (click)="doClick()"
        matRipple
        [disabled]="disabled">{{content}}</button>
